export const KIND = Object.freeze({
  info: "info",
  positive: "positive",
  warning: "warning",
  negative: "negative",
  primary: "primary",
} as const);

export const HIERARCHY = Object.freeze({
  low: "low",
  high: "high",
} as const);
